import Axios from 'axios';
import { uuid } from 'uuidv4';

export interface Output {
  passed: boolean;
  inputs: string[];
  expectedOutput: string;
  actualOutput: string;
}

export interface Test {
  outputs: Output[] | null;
  isBusy: boolean;
  errorMessage: string;
}

export interface Log {
  submissionID: number;
  personID: string;
  assignmentID: string;
  courseID: string;
  specID: string;
}

class Submission {
  public id: string;
  public name: string;
  public answer: string;
  public test: Test;

  public static async getAllIDs(): Promise<string[]> {
    const data = (await Axios.get('/admin/submissions')).data;

    return data;
  }

  public static async get(submissionID: string): Promise<Submission> {
    const { activityID, code } = (
      await Axios.get(`/admin/retrieve-submission?id=${submissionID}`)
    ).data;
    const id = activityID;
    const name = id;
    const answer = code.replace(/((\\n)+((?!\S+)|(?=})))/g, '\n') || '';

    const submission = new Submission({
      id,
      name,
      answer,
      test: { outputs: null, isBusy: false, errorMessage: '' },
    } as Submission);
    
    return submission;
  }

  public static async getSubmissionLogs(): Promise<Log[]> {
    const { logs = [] } = (await Axios.get('/admin/submission-logs')).data;

    return logs;
  }

  constructor(submission: Submission) {
    this.id = submission.id;
    this.name = submission.name;
    this.answer = submission.answer;
    this.test = submission.test;
    this.submit = this.submit.bind(this);
  }

  public async submit(): Promise<Output[]> {
    const { output = [] } = (
      await Axios.post(
        '/exam/submit',
        JSON.stringify({
          submitterID: uuid(),
          activityID: this.id,
          code: this.answer,
        })
      )
    ).data;

    return output;
  }

}

export default Submission;
